<template>
  <div class="template-edit">
    <Card shadow class="content">
      <div class="main container-template-main">
        <div style="text-align: right">
          <i-switch v-model="cmdModal" size="large">
            <span slot="open">cmd</span>
            <span slot="close">cmd</span>
          </i-switch>
        </div>
        <div v-if="cmdModal">
          <Row style="padding-top: 5px">
            <Input type="textarea" :rows="4" v-model="cmd" placeholder="命令行：docker run ..."/>
          </Row>
          <Row style="padding-top: 5px">
            <div style="float: left">
              <Poptip
                v-if="cmd"
                confirm
                transfer
                title="生成后将覆盖当前命令行，请确认"
                @on-ok="ObjectToCmdSubmit"
                ok-text="确认"
                cancel-text="取消"
                placement="bottom">
                <Button type="primary" :loading="ObjectToCmdSubmitting" size="small">生成命令行</Button>
              </Poptip>
              <Button v-else type="primary" :loading="ObjectToCmdSubmitting" @click="ObjectToCmdSubmit" size="small">生成命令行</Button>
            </div>
            <div style="float: right">
              <Button type="primary" @click="CmdToObjectSubmit" :loading="cmdToObjectSubmitting" size="small">转换成表单</Button>
            </div>
          </Row>
          <Divider/>
        </div>
        <Form ref="templateForm" :model="templateForm" :rules="templateFormRules" :label-width="70">
          <FormItem label="模板标题" prop="title">
            <Input v-model="templateForm.title" :maxlength="128" placeholder="Title" />
          </FormItem>
          <FormItem label="分类" prop="type">
            <Select v-model="templateForm.type" placeholder="" multiple filterable>
              <Option v-for="item in types" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="模板描述" prop="description">
            <Input v-model="templateForm.description" :maxlength="512" placeholder="Description" type="textarea" />
          </FormItem>
          <FormItem label="配置变量" prop="config_variable">
            <Tooltip content="替换配置中的变量，如添加一个变量`i`，在配置中变量的格式为`${i}`" max-width="200" transfer>
              <Icon type="md-help-circle" style="margin-right: 10px"/>
            </Tooltip>
            <vue-tags-input v-model="config_variable"
                            :tags="templateForm.config_variable"
                            @tags-changed="newTags => templateForm.config_variable = newTags"
                            :autocomplete-items="filteredConfigVariableItems"
                            placeholder="Config Variable"
                            class="ivu-input-wrapper" />
          </FormItem>
        </Form>
        <Form ref="addForm" :model="addForm" :rules="addFormRules" inline :label-width="70">
          <Row :gutter="48">
            <Col :md="24" :lg="12">
              <Row class="title">
                <h4 :style="{float: 'left'}">容器配置</h4>
              </Row>
              <Row>
                <FormItem label="容器名" prop="name" style="width: 100%">
                  <Input v-model="addForm.name" placeholder="Container Name"/>
                </FormItem>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">镜像配置</h4>
              </Row>
              <Row>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="镜像" prop="image" style="width: 100%">
                    <Input v-model="addForm.image" placeholder="Image"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="命令" prop="command" style="width: 100%">
                    <Input v-model="addForm.command" placeholder="Command"/>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="主机名" prop="hostname" style="width: 100%">
                    <Input v-model="addForm.hostname" placeholder="Hostname"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12" style="padding-right: 5px">
                  <FormItem label="域" prop="domainname" style="width: 100%">
                    <Input v-model="addForm.domainname" placeholder="domain"/>
                  </FormItem>
                </Col>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">重启策略</h4>
              </Row>
              <Row>
                <Form ref="restartPolicyForm" :model="restartPolicyData" :rules="restartPolicyRules" inline :label-width="70">
                  <Col :lg="12" style="padding-right: 5px">
                    <FormItem label="重启策略" style="width: 100%" prop="restartPolicyName">
                      <Select v-model="restartPolicyData.restartPolicyName">
                        <Option v-for="item in restartPolicyList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :lg="12" v-if="restartPolicyData.restartPolicyName === 'on-failure'" style="padding-right: 5px">
                    <FormItem label="失败时最大重启次数" style="width: 100%" prop="MaximumRetryCount">
                      <Input placeholder="失败时最大重启次数" v-model="restartPolicyData.MaximumRetryCount"/>
                    </FormItem>
                  </Col>
                </Form>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">网络模式</h4>
              </Row>
              <Row>
                <FormItem label="网络模式" style="width: 100%" prop="network_mode">
                  <Select v-model="addForm.network_mode">
                    <Option v-for="item in networkModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Row>
            </Col>
            <Col :md="24" :lg="12">
              <Row class="title">
                <h4 :style="{float: 'left'}">高级</h4>
              </Row>
              <Row v-if="addForm.healthcheck">
                <FormItem label="健康检测" :label-width="65">
                  <Input v-model="addForm.healthcheck.test" placeholder="Health Check" style="min-width: 200px"/>
                </FormItem>
              </Row>
              <Row v-if="addForm.healthcheck">
                <FormItem label="健康检测重试次数" :label-width="115">
                  <Input v-model="addForm.healthcheck.retries " placeholder="Health Check Retries (Default 3)" style="min-width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="PID模式" :label-width="60">
                  <Input v-model="addForm.pid_mode" placeholder="PID mode" style="width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="入口点" :label-width="55">
                  <Input v-model="addForm.entrypoint" placeholder="Entrypoint" style="width: 200px"/>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="分配伪终端 (tty)" :label-width="100">
                  <i-switch v-model="addForm.tty">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="允许容器在特权模式下运行" :label-width="160">
                  <i-switch v-model="addForm.privileged">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="内核权限" :label-width="65">
                  <i-switch v-model="kernelPermission">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row>
                <FormItem label="自动删除" :label-width="65">
                  <i-switch v-model="addForm.auto_remove">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">资源限制</h4>
              </Row>
              <Row>
                <Col :md="24" :lg="24" style="padding-right: 5px">
                  <FormItem label="Cpus限制" prop="nano_cpus" style="width: 100%">
                    <InputNumber :min="1" v-model="addForm.nano_cpus" placeholder="" type="number"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="24" style="padding-right: 5px">
                  <FormItem label="Mems限制（单位：MB）" prop="mem_limit" style="width: 100%" :label-width="150">
                    <InputNumber :min="1" v-model="addForm.mem_limit" placeholder="∞"/>
                  </FormItem>
                </Col>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">目录映射</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addVolumesItem"></Button>
              </Row>
              <Row>
                <div v-for="(volumes, index) in volumesData" :key="index">
                  <Form ref="volumesForm" :model="volumes" :rules="volumesRules" inline>
                    <Row>
                      <Col :lg="9">
                        <FormItem prop="hostPath" style="width: 100%" :label-width="5">
                          <Input v-model="volumes.hostPath" placeholder="主机路径" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="mode" style="width: 100%" :label-width="5" label="">
                          <Select v-model="volumes.mode" placeholder="模式（默认读写）" clearable>
                            <Option v-for="item in volumesModeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                      <Col :lg="9">
                        <FormItem prop="bind" style="width: 100%" :label-width="5" label="">
                          <Input v-model="volumes.bind" placeholder="容器路径">
                          <Button slot="append" icon="md-close" @click="removeVolumesItem(index)"></Button>
                          </Input>
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">容器链接</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addLinksItem"></Button>
              </Row>
              <Row>
                <div v-for="(link, index) in links" :key="index">
                  <Form ref="linkForm" :model="link" :rules="linkRules" inline>
                    <FormItem prop="container" style="width: 100%">
                      <Input v-model="link.alias" placeholder="别名（选填）" class="env-value text-dark-input">
                      <Input v-model="link.container" placeholder="容器" slot="prepend" style="min-width: 170px" size="small"/>
                      <Button slot="append" icon="md-close" @click="removeLinksItem(index)"></Button>
                      </Input>
                    </FormItem>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">容器DNS</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addDnsItem"></Button>
              </Row>
              <Row>
                <div v-for="(dns, index) in dnsData" :key="index">
                  <Form ref="dnsForm" :model="dns" :rules="dnsRules" inline>
                    <FormItem prop="dnsName" style="width: 100%">
                      <Input v-model="dns.dnsName" :placeholder="`DNS${index + 1}`" class="env-value">
                      <Button slot="append" icon="md-close" @click="removeDnsItem(index)"></Button>
                      </Input>
                    </FormItem>
                  </Form>
                </div>
              </Row>
              <Row class="title">
                <h4 :style="{float: 'left'}">端口映射</h4>
                <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addPortsItem"></Button>
              </Row>
              <Row>
                <div v-for="(port, index) in portsData" :key="index">
                  <Form ref="portsForm" :model="port" :rules="portsRules" inline>
                    <Row>
                      <Col :lg="6">
                        <FormItem prop="host_address" style="width: 100%" :label-width="5" label="">
                          <Input v-model="port.host_address" placeholder="主机监听地址" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="host_port" style="width: 100%" :label-width="5">
                          <Input v-model="port.host_port" placeholder="主机端口" />
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="protocol" style="width: 100%" :label-width="5" label="">
                          <Select v-model="port.protocol" placeholder="协议">
                            <Option v-for="item in protocolList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                      <Col :lg="6">
                        <FormItem prop="container_port" style="width: 100%" :label-width="5" label="">
                          <Input v-model="port.container_port" placeholder="容器端口">
                            <Button slot="append" icon="md-close" @click="removePortsItem(index)"></Button>
                          </Input>
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Row>
            </Col>
          </Row>
        </Form>
        <Row class="title">
          <h4 :style="{float: 'left'}">环境变量</h4>
          <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addEnvItem"></Button>
        </Row>
        <Row>
          <div v-for="(env, index) in environmentData" :key="index" style="margin-bottom: 10px">
            <Form ref="envForm" :model="env" :rules="envRules" inline>
              <Card>
                <div slot="title">
                  <FormItem style="margin-bottom: 0;width:200px;">
                    <RadioGroup v-model="env.envMode">
                      <radio v-for="envModeItem in envModeList" :key="envModeItem.value" :label="envModeItem.value">{{ envModeItem.label }}</radio>
                    </RadioGroup>
                  </FormItem>
                  <div style="float: right;
  margin-top: 8px;
">
                    <Tooltip content="移除此环境变量">
                      <Icon type="md-close-circle" size="20" color="red" v-on:click="removeEnvItem(index)" style="cursor: pointer"/>
                    </Tooltip>
                  </div>
                </div>
                <FormItem label="变量名" prop="envName" :label-width="60">
                  <Input v-model="env.envName" placeholder="Name" style="min-width: 200px"/>
                </FormItem>
                <FormItem label="变量值" prop="envValue" v-if="env.envMode === 'preset'" :label-width="60">
                  <Input v-model="env.envValue" placeholder="Value" style="min-width: 200px"/>
                </FormItem>
                <FormItem label="Label" prop="envLabel" v-if="env.envMode === 'text' || env.envMode === 'select'" :label-width="60">
                  <Input v-model="env.envLabel" placeholder="Choose a label" style="min-width: 200px"/>
                </FormItem>
                <FormItem label="描述" prop="envDescription" v-if="env.envMode === 'text' || env.envMode === 'select'" :label-width="60">
                  <Input v-model="env.envDescription" placeholder="Tooltip" style="min-width: 200px"/>
                </FormItem>
                <FormItem label="默认值" prop="envDefaultValue" v-if="env.envMode === 'text'" :label-width="60">
                  <Input v-model="env.envValue" placeholder="Default value" style="min-width: 200px"/>
                </FormItem>
                <div v-if="env.envMode === 'select'">
                  <FormItem prop="envOption" label="可选项" style="width: 100%">
                    <Button icon="md-add" size="small" style="margin: 6px 12px" @click="addEnvOptionItem(index)"></Button>
                    <div v-for="(envOptionItem, envOptionItemIndex) in env.envOption" :key="envOptionItemIndex">
                      <Input v-model="envOptionItem.envOptionValue" placeholder="选项值" class="env-value" style="margin-bottom: 5px">
                        <Input v-model="envOptionItem.envOptionName" placeholder="选项名" slot="prepend" style="width: 200px" size="small"/>
                        <Button slot="append" icon="md-close" @click="removeEnvOptionItem(index, envOptionItemIndex)"></Button>
                      </Input>
                    </div>
                  </FormItem>
                </div>
              </Card>
            </Form>
          </div>
        </Row>
        <div style="text-align: center; box-shadow: 0 4px 18px -4px rgba(0,0,0,.1); padding: 25px 0;">
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { createContainerTemplate, detailContainerTemplate, getContainerTemplateTypes } from '@/api/container/template'
import { ContainerRunCmdToObject, ContainerRunObjectToCmd } from '@/api/container/cmd'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'edit',
  components: {
    VueTagsInput
  },
  data () {
    return {
      containers: [],
      config_variable: '',
      types: [],
      templateForm: {
        title: '',
        type: [],
        description: '',
        config_variable: []
      },
      templateFormRules: {
        title: { required: true, trigger: 'blur', message: '模板标题是必填的' }
      },
      addForm: {
        name: '',
        image: '',
        command: '',
        hostname: '',
        domainname: '',
        network_mode: 'bridge',
        entrypoint: '',
        pid_mode: '',
        privileged: false,
        tty: false,
        auto_remove: false,
        cap_add: [],
        nano_cpus: null,
        mem_limit: null,
        volumes: {},
        environment: [],
        links: {},
        dns: [],
        restart_policy: {
          Name: '',
          MaximumRetryCount: null
        },
        healthcheck: {
          test: '',
          retries: ''
        }
      },
      addFormRules: {
        image: { required: true, trigger: 'change', message: '请选择要部署的镜像' },
        network_mode: { required: true, trigger: 'blur', message: '请选择网络模式' }
      },
      submitting: false,
      // 内核权限
      kernelPermission: false,
      // 挂载目录
      volumesModeList: [
        { value: 'rw', label: '读和写' },
        { value: 'ro', label: '只读' },
        { value: 'shared', label: '共享' }
      ],
      volumesData: [],
      volumesRules: {
        hostPath: { required: true, trigger: 'blur', message: '主机路径不能为空' },
        bind: { required: true, trigger: 'blur', message: '容器路径不能为空' }
        // mode: { required: true, trigger: 'change', message: '请选择映射模式' }
      },
      // 环境变量
      envModeList: [
        { label: '固定', value: 'preset' },
        { label: '填写', value: 'text' },
        { label: '选择', value: 'select' }
      ],
      environmentData: [],
      envRules: {
        envName: { required: true, trigger: 'blur', message: '变量名不能为空' },
        envValue: { required: true, trigger: 'blur', message: '变量值不能为空' },
        envLabel: { required: true, trigger: 'blur', message: 'Label不能为空' },
        envOption: { required: true, type: 'array', message: '可选项不能为空' }
      },
      // 容器链接
      links: [],
      linkRules: {
        container: { required: true, trigger: 'change', message: '请选择容器' }
      },
      // DNS
      dnsData: [],
      dnsRules: {
        dnsName: { required: true, trigger: 'blur', message: 'dns不能为空' }
      },
      // 重启策略
      restartPolicyList: [
        { value: 'no', label: '不自动重启' },
        { value: 'on-failure', label: '失败时重启' },
        { value: 'always', label: '永远自动重启' }
      ],
      restartPolicyData: {
        restartPolicyName: 'no',
        MaximumRetryCount: null
      },
      restartPolicyRules: {
        restartPolicyName: { required: true, trigger: 'blur', message: '请选择重启策略' },
        MaximumRetryCount: { required: true, trigger: 'blur', message: '请填写失败时最大重启次数' }
      },
      // 网络模式
      networkModeList: [
        { value: 'bridge', label: '桥接模式' },
        { value: 'host', label: '主机模式' },
        { value: 'none', label: '缺省模式' }
      ],
      // 端口映射
      protocolList: [
        { value: 'tcp', label: 'TCP' },
        { value: 'udp', label: 'UDP' }
      ],
      portsData: [],
      portsRules: {
        container_port: { required: true, trigger: 'blur', message: '容器端口不能为空' },
        protocol: { required: true, trigger: 'change', message: '请选择协议' },
        host_address: { required: true, trigger: 'blur', message: '主机监听地址不能为空' },
        host_port: { required: true, trigger: 'blur', message: '主机断开不能为空' }
      },

      // 命令行
      cmdModal: false,
      cmdToObjectSubmitting: false,
      ObjectToCmdSubmitting: false,
      cmd: ''
    }
  },
  created: function () {
    this.init()
    this.getTypes()
  },
  computed: {
    filteredConfigVariableItems () {
      return this.templateForm.config_variable.filter(i => {
        return i.text.toLowerCase().indexOf(this.config_variable.toLowerCase()) !== -1
      })
    }
  },
  methods: {
    // 初始化
    init () {
      if (this.$route.params.id) {
        this.getData()
      }
    },
    getData () {
      this.resetForm()
      detailContainerTemplate(this.$route.params.id).then(res => {
        this.templateForm.title = res.data.title
        this.templateForm.type = res.data.type.map(item => item.id)
        this.templateForm.description = res.data.description
        if (res.data.config_variable && !$.isEmptyObject(res.data.config_variable)) {
          this.templateForm.config_variable = res.data.config_variable
        }
        const result = res.data.config
        const environments = res.data.environments
        if (result.name) {
          this.addForm.name = result.name
        }
        if (result.image) {
          this.addForm.image = result.image
        }
        if (result.command) {
          this.addForm.command = result.command
        }
        if (result.hostname) {
          this.addForm.hostname = result.hostname
        }
        if (result.domainname) {
          this.addForm.domainname = result.domainname
        }
        if (result.entrypoint) {
          this.addForm.entrypoint = result.entrypoint
        }
        if (result.pid_mode) {
          this.addForm.pid_mode = result.pid_mode
        }
        if (result.auto_remove) {
          this.addForm.auto_remove = result.auto_remove
        }
        if (result.restart) {
          this.restartPolicyData.restartPolicyName = result.restart
        }
        if (result.network_mode) {
          this.addForm.network_mode = result.network_mode
        }
        if (result.healthcheck && result.healthcheck.test) {
          this.addForm.healthcheck.test = result.healthcheck.test
        }
        if (result.healthcheck && result.healthcheck.retries) {
          this.addForm.healthcheck.retries = result.healthcheck.retries
        }
        if (result.tty) {
          this.addForm.tty = result.tty
        }
        if (result.privileged) {
          this.addForm.privileged = result.privileged
        }
        if (result.cap_add && result.cap_add.indexOf('ALL') > -1) {
          this.kernelPermission = true
        }
        if (result.nano_cpus) {
          this.addForm.nano_cpus = result.nano_cpus
        }
        if (result.mem_limit) {
          this.addForm.mem_limit = parseInt(result.mem_limit.split('m')[0])
        }
        if (result.volumes) {
          for (let i in result.volumes) {
            this.volumesData.push({
              hostPath: i,
              bind: result.volumes[i].bind,
              mode: result.volumes[i].mode
            })
          }
        }
        if (result.links) {
          for (let i in result.links) {
            this.links.push({
              container: i,
              alias: result.links[i]
            })
          }
        }
        if (result.dns) {
          for (let i in result.dns) {
            this.dnsData.push({
              dnsName: result.dns[i]
            })
          }
        }
        if (result.ports) {
          for (let i in result.ports) {
            const port = result.ports[i]
            let host = i.split('/')
            let protocol = 'tcp'
            if (host.length > 1) {
              protocol = host[1]
            }
            this.portsData.push({
              container_port: host[0],
              protocol: protocol,
              host_address: port[0],
              host_port: port[1]
            })
          }
        }
        if (environments) {
          for (let i in environments) {
            this.addEnvItem()
            let envLen = this.environmentData.length
            for (let v in environments[i]) {
              this.environmentData[envLen - 1][v] = environments[i][v]
            }
          }
        }
      })
    },
    addVolumesItem () {
      this.volumesData.push({
        hostPath: '',
        bind: '',
        mode: ''
      })
    },
    removeVolumesItem (index) {
      this.volumesData.splice(index, 1)
    },
    addEnvItem () {
      this.environmentData.push({
        envMode: 'preset',
        envName: '',
        envValue: '',
        envLabel: '',
        envDescription: '',
        envOption: [
          {
            envOptionName: '',
            envOptionValue: ''
          },
          {
            envOptionName: '',
            envOptionValue: ''
          }
        ]
      })
    },
    removeEnvItem (index) {
      this.environmentData.splice(index, 1)
    },
    addEnvOptionItem (index) {
      this.environmentData[index].envOption.push({
        envOptionName: '',
        envOptionValue: ''
      })
    },
    removeEnvOptionItem (index, optionIndex) {
      this.environmentData[index].envOption.splice(optionIndex, 1)
    },
    addLinksItem () {
      this.links.push({
        container: '',
        alias: null
      })
    },
    removeLinksItem (index) {
      this.links.splice(index, 1)
    },
    addDnsItem () {
      this.dnsData.push({
        dnsName: ''
      })
    },
    removeDnsItem (index) {
      this.dnsData.splice(index, 1)
    },
    addPortsItem () {
      this.portsData.push({
        container_port: '',
        protocol: 'tcp',
        host_address: '0.0.0.0',
        host_port: ''
      })
    },
    removePortsItem (index) {
      this.portsData.splice(index, 1)
    },
    getTypes () {
      getContainerTemplateTypes().then(res => {
        this.types = res.data
      }).catch(res => {
        console.error(res.response)
      })
    },
    resetForm () {
      this.templateForm = {
        title: '',
        type: [],
        description: '',
        config_variable: []
      }
      this.addForm = {
        name: '',
        image: '',
        command: '',
        hostname: '',
        domainname: '',
        network_mode: 'bridge',
        entrypoint: '',
        pid_mode: '',
        privileged: false,
        tty: false,
        auto_remove: false,
        cap_add: [],
        nano_cpus: null,
        mem_limit: null,
        volumes: {},
        environment: [],
        links: {},
        dns: [],
        restart_policy: {
          Name: '',
          MaximumRetryCount: null
        },
        healthcheck: {
          test: '',
          retries: ''
        }
      }
      this.kernelPermission = false
      this.volumesData = []
      this.environmentData = []
      this.links = []
      this.dnsData = []
      this.restartPolicyData = {
        restartPolicyName: 'no',
        MaximumRetryCount: null
      }
      this.portsData = []
    },
    validForm (submit = true) {
      let allValid = true
      if (submit) {
        this.$refs.templateForm.validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      this.$refs.restartPolicyForm.validate((valid) => {
        if (!valid) {
          allValid = false
        }
      })
      for (let i in this.$refs.volumesForm) {
        this.$refs.volumesForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.envForm) {
        this.$refs.envForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.linkForm) {
        this.$refs.linkForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.dnsForm) {
        this.$refs.dnsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      for (let i in this.$refs.portsForm) {
        this.$refs.portsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      return allValid
    },
    getRunReqData (env = false) {
      let reqData = {
        network_mode: this.addForm.network_mode,
        privileged: this.addForm.privileged,
        auto_remove: this.addForm.auto_remove,
        tty: this.addForm.tty
      }
      if (this.addForm.name) {
        reqData.name = this.addForm.name
      }
      if (this.addForm.hostname) {
        reqData.hostname = this.addForm.hostname
      }
      if (this.addForm.domainname) {
        reqData.domainname = this.addForm.domainname
      }
      if (this.restartPolicyData.restartPolicyName !== 'no') {
        reqData.restart_policy = {
          Name: this.restartPolicyData.restartPolicyName
        }
        if (this.restartPolicyData.restartPolicyName === 'on-failure') {
          reqData.restart_policy.MaximumRetryCount = parseInt(this.restartPolicyData.MaximumRetryCount)
        }
      }
      if (this.addForm.entrypoint) {
        reqData.entrypoint = this.addForm.entrypoint
      }
      if (this.addForm.pid_mode) {
        reqData.pid_mode = this.addForm.pid_mode
      }
      if (this.addForm.healthcheck && this.addForm.healthcheck.test) {
        reqData.healthcheck = this.addForm.healthcheck
        if (!reqData.healthcheck.retries) {
          reqData.healthcheck.retries = 3
        } else {
          reqData.healthcheck.retries = parseInt(reqData.healthcheck.retries)
        }
      }
      if (this.kernelPermission) {
        reqData.cap_add = ['ALL']
      }
      if (this.addForm.nano_cpus) {
        reqData.nano_cpus = parseInt(this.addForm.nano_cpus)
      }
      if (this.addForm.mem_limit) {
        reqData.mem_limit = this.addForm.mem_limit + 'm'
      }
      if (this.volumesData.length) {
        reqData.volumes = {}
        for (let i in this.volumesData) {
          const item = this.volumesData[i]
          reqData.volumes[item.hostPath] = {
            bind: item.bind,
            mode: item.mode
          }
        }
      }
      if (this.links.length) {
        reqData.links = {}
        for (let i in this.links) {
          const item = this.links[i]
          reqData.links[item.container] = item.alias ? item.alias : null
        }
      }
      if (this.dnsData.length) {
        reqData.dns = this.dnsData.map(item => item.dnsName)
      }
      if (this.portsData.length) {
        reqData.ports = {}
        for (let i in this.portsData) {
          const item = this.portsData[i]
          reqData.ports[`${item.container_port}/${item.protocol}`] = [item.host_address, item.host_port]
        }
      }
      if (env && this.environmentData.length) {
        reqData.environment = []
        for (let v in this.environmentData) {
          const item = this.environmentData[v]
          if (item.envMode === 'preset') {
            reqData.environment.push(`${item.envName}=${item.envValue}`)
          }
        }
      }
      reqData.image = this.addForm.image
      if (this.addForm.command) {
        reqData.command = this.addForm.command
      }
      return reqData
    },
    submit () {
      const allValid = this.validForm()
      if (allValid) {
        const containerData = this.getRunReqData()
        if (containerData) {
          let reqData = {
            title: this.templateForm.title,
            type: this.templateForm.type,
            description: this.templateForm.description,
            config_variable: this.templateForm.config_variable,
            config: containerData
          }
          if (this.environmentData.length) {
            reqData.environments = []
            for (let v in this.environmentData) {
              const item = this.environmentData[v]
              let res = {
                envMode: item.envMode,
                envName: item.envName
              }
              if (item.envMode === 'preset') {
                res.envValue = item.envValue
              } else if (item.envMode === 'text') {
                res.envValue = item.envValue
                res.envLabel = item.envLabel
                res.envDescription = item.envDescription
              } else if (item.envMode === 'select') {
                for (let i in item.envOption) {
                  if (!item.envOption[i].envOptionName) {
                    this.$Notice.warning({title: '环境变量的选项名不能为空'})
                    return false
                  }
                  if (!item.envOption[i].envOptionValue) {
                    this.$Notice.warning({title: '环境变量的选项值不能为空'})
                    return false
                  }
                }
                res.envLabel = item.envLabel
                res.envDescription = item.envDescription
                res.envOption = item.envOption
              }
              reqData.environments.push(res)
            }
          }
          this.submitting = true
          createContainerTemplate(reqData, this.$route.params.id).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'container_template'})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
    },
    ObjectToCmdSubmit () {
      const allValid = this.validForm(false)
      if (allValid) {
        const reqData = this.getRunReqData(true)
        this.ObjectToCmdSubmitting = true
        ContainerRunObjectToCmd(reqData).then(res => {
          this.cmd = res.data
          this.cmdModal = true
          this.ObjectToCmdSubmitting = false
          this.$Notice.success({title: '生成成功'})
        }).catch(res => {
          this.ObjectToCmdSubmitting = false
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
    },
    CmdToObjectSubmit () {
      if (!this.cmd) {
        this.$Notice.warning({
          title: '命令不能为空！'
        })
        return
      }
      this.cmdToObjectSubmitting = true
      ContainerRunCmdToObject(this.cmd).then(res => {
        this.resetForm()
        const result = res.data
        if (result.name) {
          this.addForm.name = result.name
        }
        if (result.image) {
          this.addForm.image = result.image
        }
        if (result.command) {
          this.addForm.command = result.command
        }
        if (result.hostname) {
          this.addForm.hostname = result.hostname
        }
        if (result.domainname) {
          this.addForm.domainname = result.domainname
        }
        if (result.restart) {
          this.restartPolicyData.restartPolicyName = result.restart
        }
        if (result.health_cmd) {
          this.addForm.healthcheck.test = result.health_cmd
        }
        if (result.health_retries) {
          this.addForm.healthcheck.retries = result.health_retries
        }
        if (result.network) {
          this.addForm.network_mode = result.network
        } else if (result.net) {
          this.addForm.network_mode = result.net
        }
        if (result.tty) {
          this.addForm.tty = result.tty
        }
        if (result.rm) {
          this.addForm.auto_remove = result.rm
        }
        if (result.entrypoint) {
          this.addForm.entrypoint = result.entrypoint
        }
        if (result.pid_mode) {
          this.addForm.pid_mode = result.pid_mode
        }
        if (result.privileged) {
          this.addForm.privileged = result.privileged
        }
        if (result.cap_add && result.cap_add.indexOf('ALL') > -1) {
          this.kernelPermission = true
        }
        if (result.cpus) {
          this.addForm.nano_cpus = parseInt(result.cpus)
        }
        if (result.memory) {
          this.addForm.mem_limit = Math.round(parseInt(result.memory) / 1024 / 1024)
        }
        if (result.volume) {
          for (let i in result.volume) {
            const volume = result.volume[i].split(':')
            this.volumesData.push({
              hostPath: volume[0],
              bind: volume[1],
              mode: volume.length > 2 ? volume[2] : ''
            })
          }
        }
        if (result.env) {
          for (let i in result.env) {
            const env = result.env[i].split('=')
            this.environmentData.push({
              envMode: 'preset',
              envName: env[0],
              envValue: env[1],
              envLabel: '',
              envDescription: '',
              envOption: [
                {
                  envOptionName: '',
                  envOptionValue: ''
                },
                {
                  envOptionName: '',
                  envOptionValue: ''
                }
              ]
            })
          }
        }
        if (result.link) {
          for (let i in result.link) {
            const link = result.link[i].split(':')
            this.links.push({
              container: link[0],
              alias: link.length > 1 ? link[1] : null
            })
          }
        }
        if (result.dns) {
          for (let i in result.dns) {
            this.dnsData.push({
              dnsName: result.dns[i]
            })
          }
        }
        if (result.publish) {
          for (let i in result.publish) {
            const port = result.publish[i].split(':')
            let host = port[1].split('/')
            if (port.length > 2) {
              host = port[2].split('/')
            }
            this.portsData.push({
              container_port: host[0],
              protocol: host.length > 1 ? host[1] : 'tcp',
              host_address: port.length > 2 ? port[0] : '0.0.0.0',
              host_port: port.length > 2 ? port[1] : port[0]
            })
          }
        }
        this.cmdToObjectSubmitting = false
        this.$Notice.success({title: '转换成功'})
      }).catch(res => {
        this.cmdToObjectSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '命令有误！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '命令有误！'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .env-value .ivu-input-default {
    height: 34px;
  }
  .container-template-main {
    .ti-input {
      display: inline-block;
      width: 100%;
      line-height: 1.5;
      padding: 4px 7px;
      font-size: 12px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      color: #515a6e;
      background-color: #fff;
      background-image: none;
      position: relative;
      cursor: text;
      transition: border 0.2s ease-in-out, background 0.2s ease-in-out, box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
    }
    .vue-tags-input .ti-tag {
      color: #2d8cf0;
      background-color: transparent;
      border: 1px solid #2d8cf0
    }
  }
</style>
